export const AWARDS_DATA = [
  {
    iconSrc: require("./assets/standeee Awards-02.jpg"),
    desc: "Virtual Edition Speaker For The Event Mr. Swagat Hitesh Vyas",
  },
  {
    iconSrc: require("./assets/standeee Awards-03.jpg"),
    desc: "Promising & Innovative Developer Mr. Swagat Hitesh Vyas",
  },
  {
    iconSrc: require("./assets/standeee Awards-04.jpg"),
    desc: "For Best Work Quality In Real Estate To Mr. Hitesh Vyas",
  },
  {
    iconSrc: require("./assets/standeee Awards-02.jpg"),
    desc: "Excellence In Creating Landmark Projects (Real Estate)",
  },
  {
    iconSrc: require("./assets/standeee Awards-05.jpg"),
    desc: "MID - Segment Project of the Year for VISHWANATH SARATHYA",
  },
  {
    iconSrc: require("./assets/standeee Awards-06.jpg"),
    desc: "MID - Segment Project of the Year for VISHWANATH SOPAN",
  },
  {
    iconSrc: require("./assets/standeee Awards-07.jpg"),
    desc: "MID - Segment Project of the Year for VISHWANATH SAMAM",
  },
  {
    iconSrc: require("./assets/standeee Awards-08.jpg"),
    desc: "Affortable Housing Project of the Year for VISHWANATH SARATHYA",
  },
  {
    iconSrc: require("./assets/standeee Awards-09.jpg"),
    desc: "Future Of Office & Retails Reimagining Commercial Properties",
  },
  {
    iconSrc: require("./assets/standeee Awards-10.jpg"),
    desc: "Constitution World Stalwarts of the Gujarat Awarded to VISHWANATH BUILDERS",
  },
  {
    iconSrc: require("./assets/standeee Awards-11.jpg"),
    desc: "Vishwanath Sarathya West Excellent & Popular Residential & Commercial Project In West",
  },
  
];
